import { FormattedMessage } from 'react-intl';

import UpgradesBubble from '../UpgradesBubble';
import AccountMenuLink from './AccountMenuLink';
import messages from './ListItems.messages';

const ListItems = () => {
  return (
    <ul className="account-snippet-menu">
      <AccountMenuLink href="/account">
        <FormattedMessage {...messages.myAccount} />
      </AccountMenuLink>
      <AccountMenuLink href="/products/my-komplete-offers/">
        <FormattedMessage {...messages.myKompleteOffers} /> <UpgradesBubble />
      </AccountMenuLink>
      <AccountMenuLink href="/my-account/my-products-serials-downloads/">
        <FormattedMessage {...messages.myProductSerials} />
      </AccountMenuLink>
      <AccountMenuLink href="/my-account/account-settings/">
        <FormattedMessage {...messages.accountSettings} />
      </AccountMenuLink>
      <AccountMenuLink href="/account/orders/">
        <FormattedMessage {...messages.orders} />
      </AccountMenuLink>
      <AccountMenuLink href="/support/downloads/">
        <FormattedMessage {...messages.downloads} />
      </AccountMenuLink>
      <AccountMenuLink href="/account/subscription/">
        <FormattedMessage {...messages.subscription} />
      </AccountMenuLink>
    </ul>
  );
};

export default ListItems;
